import { Outlet } from "react-router-dom";

export default function SettingsLayout() {
  return <Outlet />;
}
